import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopunedailycabservice() {



const cardData = {
  keyword: " Mumbai to Pune Daily Cabs   ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Pune daily cab service, ensuring a hassle-free and punctual commute for business travelers, professionals, and regular passengers. Our professional drivers, well-maintained vehicles, and timely pickups make daily travel between Mumbai and Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for daily Mumbai to Pune cab travel.",

topPlaces: [

  {
    title: "Sinhagad Fort",
    description: "Sinhagad Fort is a famous hill fort near Pune known for its historical importance and scenic views. Travelers from Mumbai can take a short excursion during their daily commute to enjoy trekking trails, explore ancient gates and bastions, and experience panoramic views of the Sahyadri mountains. The fort also offers traditional Maharashtrian food at local stalls, enhancing the visit experience."
  },
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is a revered temple in Pune dedicated to Lord Ganesha. Daily commuters from Mumbai often stop here to seek blessings and experience the vibrant spiritual atmosphere. The temple is beautifully decorated throughout the year and sees increased footfall during Ganesh Chaturthi. Nearby markets offer flowers, sweets, and religious items for devotees."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva and carved from a single rock. Located in central Pune, it is known for its unique architecture and peaceful surroundings. Travelers from Mumbai can explore the temple’s stone pillars and carvings, making it ideal for meditation, photography, and a serene spiritual experience."
  },
    {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is one of Pune’s most iconic historical landmarks and once served as the residence of the Peshwas of the Maratha Empire. Daily travelers from Mumbai can visit this landmark to explore its massive entrance gates, strong fort walls, and ruins of the grand palace complex. The site also features an evening light and sound show narrating the fascinating history of the Maratha dynasty. It’s a popular spot for photography, cultural exploration, and leisurely walks."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a historically significant monument in Pune associated with Mahatma Gandhi and India’s freedom struggle. Travelers commuting daily from Mumbai can admire its Italian-style architecture, beautifully maintained gardens, and the museum displaying historical artifacts. The serene environment makes it ideal for cultural visits, photography, and learning about India’s independence movement."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases thousands of artifacts representing Indian heritage and craftsmanship. Daily cab travelers from Mumbai can explore exhibits of musical instruments, sculptures, decorative objects, and traditional household items. The museum offers insights into India’s culture, art, and historical lifestyle, making it a must-visit for cultural enthusiasts."
  },
  {
    title: "Parvati Hill Temple",
    description: "Parvati Hill Temple is one of Pune’s oldest heritage sites and provides panoramic views of the city. Travelers commuting daily from Mumbai can climb the steps to reach the temple complex dedicated to Lord Shiva and other deities. The hilltop location is ideal for sightseeing, photography, and enjoying peaceful moments overlooking Pune."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a scenic reservoir on the outskirts of Pune, popular among nature lovers. Daily commuters from Mumbai can enjoy lake views, fresh breezes, and picturesque sunsets. The area is ideal for picnics, photography, and relaxing walks while appreciating the surrounding hills and natural beauty."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden, also known as Pu La Deshpande Garden, is a Japanese-style landscaped garden in Pune. Travelers from Mumbai can stroll through pathways lined with lotus ponds, bonsai trees, and lush greenery. The serene setting makes it perfect for relaxation, nature walks, and photography during daily visits."
  },
  {
    title: "Lal Mahal",
    description: "Lal Mahal is a historic palace linked to the childhood of Chhatrapati Shivaji Maharaj and an important cultural landmark in Pune. Daily cab travelers from Mumbai can explore the reconstructed palace featuring sculptures and exhibits depicting Shivaji Maharaj’s life. It offers insights into Maratha history and Pune’s rich cultural heritage."
  }
],



services: [
{
name: "Mumbai to Pune Daily Taxi Fare",
description: "Mumbai to Pune daily taxi fare service offers affordable and transparent pricing for regular travelers commuting between the two cities. This service is ideal for office commuters, business professionals, and frequent travelers who require consistent travel options. Customers can choose from sedan, Ertiga, and Innova Crysta vehicles depending on comfort and budget. Daily fare plans are designed to provide cost-effective solutions with no hidden charges, including tolls and driver allowance details. Smooth travel via the Mumbai–Pune Expressway ensures reduced travel time and a comfortable journey. Easy online booking and flexible scheduling make this service highly convenient for everyday travel needs."
},
{
name: "Mumbai Airport to Pune Daily Cab Service",
description: "Mumbai Airport to Pune daily cab service provides reliable pickup and drop from airport terminals to Pune city. This service is ideal for travelers arriving daily at Mumbai airport and heading to Pune for work or personal travel. Professional drivers track flight timings and ensure timely pickups. Comfortable air-conditioned vehicles ensure a relaxed journey after long flights. Multiple vehicle options including sedan, Ertiga, and Innova Crysta are available for different travel needs. With consistent service availability and easy online booking, this option is perfect for frequent flyers traveling between Mumbai and Pune."
},
{
name: "Bandra Terminus to Pune Daily Cab",
description: "Bandra Terminus to Pune daily cab service offers convenient travel for passengers arriving by train. With direct pickup from Bandra Terminus, this service ensures a smooth transition from railway to road travel. Comfortable vehicles and experienced drivers provide safe and timely travel to Pune."
},
{
name: "Dadar to Pune Daily Cab Service",
description: "Dadar to Pune daily cab service is widely used by commuters traveling regularly between Mumbai and Pune. With frequent availability and flexible pickup timings, this service ensures convenient travel. Comfortable vehicles and professional drivers ensure safe highway journeys."
},
{
name: "Mumbai Central to Pune Daily Taxi Service",
description: "Mumbai Central to Pune daily taxi service provides reliable transportation for daily commuters and travelers. Pickup is available directly from the railway station and nearby areas. Smooth expressway connectivity ensures quick and comfortable travel."
},
{
name: "Borivali to Pune Daily Taxi Fare",
description: "Borivali to Pune daily taxi fare service offers affordable pricing for regular travelers. This service is ideal for residents in Western suburbs traveling frequently to Pune for work or personal reasons."
},
{
name: "Andheri to Pune Daily Taxi Fare",
description: "Andheri to Pune daily taxi fare service provides convenient travel options for professionals and families. With easy pickup from Andheri East and West, travelers can enjoy comfortable rides with experienced drivers."
},
{
name: "Navi Mumbai to Pune Daily Cab",
description: "Navi Mumbai to Pune daily cab service offers reliable travel for residents of Vashi, Nerul, Airoli, and surrounding areas. This service is ideal for daily commuters and corporate travel with flexible pickup options."
},
{
name: "Thane to Pune Daily Cab Service",
description: "Thane to Pune daily cab service provides dependable travel for commuters traveling regularly between Thane and Pune. With comfortable vehicles and experienced drivers, passengers can enjoy smooth and safe journeys."
},
{
name: "Mumbai Pune One Way Daily Cab",
description: "Mumbai Pune one way daily cab service offers cost-effective travel for passengers requiring single-direction daily trips. It is ideal for office commuters and business travel with flexible booking options."
},
{
name: "Navi Mumbai to Pune Daily Cab Service",
description: "Navi Mumbai to Pune daily cab service ensures consistent and reliable travel for frequent travelers. This service includes door-to-door pickup and drop with comfortable vehicles and professional drivers."
},
{
name: "Mumbai to Pune Daily Cab Service",
description: "Mumbai to Pune daily cab service provides regular and dependable transportation between the two cities. With flexible schedules, comfortable vehicles, and professional drivers, this service is perfect for daily commuters and corporate travel."
},
{
name: "Mumbai to Pune Daily Cabs",
description: "Mumbai to Pune daily cabs offer multiple travel options for passengers with varying needs. Customers can choose from budget and premium vehicles for comfortable daily travel."
},
{
name: "Mumbai to Pune Daily Taxi Service",
description: "Mumbai to Pune daily taxi service ensures smooth and reliable travel with experienced drivers and well-maintained vehicles for a stress-free journey."
},
{
name: "Mumbai to Pune Daily Cab Booking",
description: "Mumbai to Pune daily cab booking allows passengers to reserve taxis easily through online platforms with instant confirmation and flexible timing options."
},
{
name: "Mumbai to Pune Shared Cab Daily",
description: "Mumbai to Pune shared cab daily service offers economical travel by sharing rides with other passengers. It is a budget-friendly option for daily commuters."
},
{
name: "Mumbai to Pune One Way Cab",
description: "Mumbai to Pune one way cab service provides affordable travel for passengers requiring single-direction trips without return charges."
},
{
name: "Mumbai to Pune Taxi Service",
description: "Mumbai to Pune taxi service offers reliable intercity travel with comfortable vehicles and experienced drivers ensuring safe journeys."
},
{
name: "Mumbai to Pune Cab Booking Online",
description: "Mumbai to Pune cab booking online allows quick and easy reservations with transparent pricing and instant confirmation for hassle-free travel."
},
{
name: "Mumbai to Pune Daily Travel Cab",
description: "Mumbai to Pune daily travel cab service provides consistent and comfortable transportation for frequent travelers with flexible scheduling."
},
{
name: "Mumbai to Pune Regular Cab Service",
description: "Mumbai to Pune regular cab service ensures dependable daily travel with professional drivers and well-maintained vehicles."
},
{
name: "Mumbai to Pune Cab Service Daily",
description: "Mumbai to Pune cab service daily offers reliable and comfortable travel options for passengers commuting regularly between Mumbai and Pune."
}
],

tableData: [
["Mumbai to Pune Daily Taxi Fare","Mumbai Airport to Pune Daily Cab Service"],
["Bandra Terminus to Pune Daily Cab","Dadar to Pune Daily Cab Service"],
["Mumbai Central to Pune Daily Taxi Service","Borivali to Pune Daily Taxi Fare"],
["Andheri to Pune Daily Taxi Fare","Navi Mumbai to Pune Daily Cab"],
["Thane to Pune Daily Cab Service","Mumbai Pune One Way Daily Cab"],
["Navi Mumbai to Pune Daily Cab Service","Mumbai to Pune Daily Cab Service"],
["Mumbai to Pune Daily Cabs","Mumbai to Pune Daily Taxi Service"],
["Mumbai to Pune Daily Cab Booking","Mumbai to Pune Shared Cab Daily"],
["Mumbai to Pune One Way Cab","Mumbai to Pune Taxi Service"],
["Mumbai to Pune Cab Booking Online","Mumbai to Pune Daily Travel Cab"],
["Mumbai to Pune Regular Cab Service","Mumbai to Pune Cab Service Daily"]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Daily Cab Service",
    WhyChoosedescription: "Velocity Cabs offers dependable Mumbai to Pune daily cabs for regular commuters, office travelers, and business trips with consistent service and on-time pickups."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who frequently operate daily routes between Mumbai and Pune via the Mumbai Pune Expressway, ensuring safe and timely travel."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "Velocity Cabs offers cost-effective and transparent pricing for Mumbai to Pune daily cabs. Customers receive clear fare details including toll charges and driver allowance before booking."
  },
  {
    WhyChooseheading: "24/7 Daily Cab Availability",
    WhyChoosedescription: "Our Mumbai to Pune daily cab service operates round the clock. Whether you need early morning office travel or late-night return, Velocity Cabs ensures availability anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable and hassle-free daily travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Monthly Plans",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way daily rides, round-trip bookings, and customized monthly cab plans for frequent travelers between Mumbai and Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals and corporate groups."
  },
  {
    WhyChooseheading: "Trusted Daily Travel Partner",
    WhyChoosedescription: "Velocity Cabs is trusted by many daily commuters for Mumbai to Pune travel thanks to punctual drivers, comfortable vehicles, and professional intercity cab service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Pune daily cab service?", answer: "Yes, Velocity Cabs provides reliable daily cab services between Mumbai and Pune for regular commuters and corporate travelers." },
  { question: "Is Mumbai to Pune daily cab service available 24 hours?", answer: "Yes, our daily cab service operates 24/7 to match your travel schedule." },
  { question: "How far is Mumbai from Pune?", answer: "The road distance between Mumbai and Pune is approximately 150 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Which vehicles are available for daily travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way daily cab?", answer: "Yes, we provide one-way as well as round-trip daily cab services between Mumbai and Pune." },
  { question: "Do you offer monthly cab plans?", answer: "Yes, Velocity Cabs offers customized monthly travel plans for daily commuters and corporate clients." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable daily travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai to Pune daily cabs online or through phone booking." },
  { question: "Do you provide pickup from home or office?", answer: "Yes, we provide doorstep pickup from homes, offices, and business locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Shah",
    feedback:
      "Using Velocity Cabs daily between Mumbai and Pune for office travel. Always punctual and very comfortable ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "Best daily cab service for Mumbai to Pune travel. Clean cars and professional drivers make daily commuting easy.",
    rating: 5
  }
];






























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const mumbaiToPuneDailyJSON = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai to Pune Daily Cabs | Velocity Cabs",
  "description": "Reliable daily cab service from Mumbai to Pune with Velocity Cabs. Options include one-way, round trip, and airport drop cabs. Cars available: Innova, Ertiga, Sedan.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "Daily Cab Service Mumbai to Pune",
    "Mumbai Airport to Pune Daily Cab",
    "One-way Daily Cab Mumbai to Pune",
    "Round Trip Daily Cab",
    "Outstation Taxi Mumbai to Pune"
  ],
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Mumbai to Pune Daily Cabs | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book reliable daily cabs from Mumbai to Pune with Velocity Cabs. One-way, round trips, and airport drop options. Innova, Ertiga, and Sedan cars available."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiToPuneDailyJSON)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/66.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopunedailycabservice;